<template>
    <div class="onboardingscreen-content">
        <div
            class="onboardingscreen-content__description typographies-paragraph-large-semibold"
            v-html="
                $t.__('onboarding.OnboardingScreen.title', {
                    startLink: '<a href=\'mailto:contact@sellsy.com\'>',
                    endLink: '</a>',
                })
            "
        />
        <div class="onboardingscreen-content__columns">
            <preloader :display="isLoading" />
            <div
                v-for="(column, index) in columns"
                :key="`onboardingscreen-column-${index}`"
                class="onboardingscreen-content__columns--column"
            >
                <div
                    class="onboardingscreen-content__columns--column-heading typographies-paragraph-large-bold"
                >
                    {{ column.label }}
                </div>

                <div
                    v-for="card in column.cards"
                    :key="`onboardingscreen-card-${card.code}`"
                    class="onboardingscreen-content__columns--column-card"
                    :data-bot="card.code"
                    @click="goToCardUrl(card.url)"
                >
                    <CompassObject :label="card.label" :object="card.icon" />
                </div>
            </div>
        </div>

        <div class="onboardingscreen-content__buttons">
            <CompassButton
                v-if="isVariationDemoButtonAtBottom"
                data-bot="ask-for-demo-bottom"
                :label="$t.__('common.actions.ask_demo')"
                @click="redirectTo('https://go.sellsy.com/demande-de-rendez-vous', '_blank')"
            >
            </CompassButton>
            <CompassButton
                :label="$t.__('onboarding.OnboardingScreen.view_help')"
                type="tertiary"
                @click="redirectTo('https://help.sellsy.com/fr/', '_blank')"
            >
            </CompassButton>
        </div>
    </div>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import Feature from 'Services/Feature';

export default {
    components: { Preloader },
    props: {
        columns: {
            type: Array,
            required: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isVariationDemoButtonAtBottom() {
            return Feature.isVariation('onboarding-screen-abtest-button', 'demo-button-at-bottom');
        },
    },
    methods: {
        goToCardUrl(cardUrl) {
            cardUrl.startsWith('https://')
                ? window.open(cardUrl, '_blank')
                : window.location.assign(cardUrl);
        },
        redirectTo(url, target) {
            window.open(url, target);
        },
    },
};
</script>

<style lang="scss" scoped>
.onboardingscreen-content {
    &__description {
        margin-bottom: var(--spacing-5);
        color: var(--colors-common-text-standard-caption);
    }

    &__columns {
        position: relative;

        display: flex;
        gap: var(--spacing-4);
        align-items: stretch;

        min-height: 375px;
        margin-bottom: var(--spacing-6);

        &--column {
            display: flex;
            flex-direction: column;
            gap: var(--spacing-1);
            align-items: stretch;

            width: calc(25% - ((3 / 4) * var(--spacing-4)));
            padding: var(--spacing-3);

            background-color: var(--colors-common-background-app);
            border-radius: 8px;

            &-card {
                cursor: pointer;
                padding: var(--spacing-3);
                background-color: var(--colors-common-background-default);
                border-radius: 4px;

                &:hover {
                    background-color: var(--colors-common-background-hover);
                }
            }
        }
    }

    &__buttons {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-3);
        align-items: center;
    }
}
</style>

<style lang="scss">
.onboardingscreen-content {
    &__description {
        a {
            transition-duration: 100ms;
            transition-property: color;

            &:hover {
                color: var(--colors-common-text-primary-hover);
            }
        }
    }

    &__columns {
        &--column {
            .compass-object {
                align-items: flex-start;

                &__label {
                    font-size: var(--font-size-14);
                    font-weight: var(--font-weights-lato-1);
                    line-height: var(--line-heights-20);
                }
            }
        }
    }
}
</style>
